import { readHomeCache, saveHomeCache, removeHomeCache } from "@/services/homeCache"

const copy = (value) => JSON.parse(JSON.stringify(value))

export function readOverview(state, key, scope) {
  const cached = state[key]
  return scope ? (cached?.scope === scope ? copy(cached.data) : readHomeCache(key, scope)) : null
}

export function compactCalendar(calendar) {
  return calendar.map((day) => ({
    ts: day.ts,
    short: day.short,
    today: day.today,
    hasActivity: Boolean(day.hasActivity || day.foundWorkouts?.length || day.courseArray?.length || day.courses?.length || day.checkins?.length),
  }))
}

export function compactCourses(courses) {
  return courses.map((course) => ({
    _id: course._id,
    courseTimelineId: course.courseTimelineId,
    course: { name: course.course?.name, bild: course.course?.bild },
    hours: course.hours,
    minutes: course.minutes,
    duration: course.duration,
    cancelled: course.cancelled,
    signedUp: course.signedUp,
    onQueue: course.onQueue,
    signupAmount: course.signupAmount,
    amount: course.amount,
    instructors: (course.instructors || []).map((instructor) => ({ vorname: instructor.vorname })),
  }))
}

export const homeOverviewStore = {
  namespaced: true,
  // One snapshot per section, plus a bounded local copy for reloads. No workout/health details.
  state: { calendar: null, upcoming: null, courses: null, contracts: null, balance: null },
  mutations: {
    reset(state) {
      Object.keys(state).forEach((key) => { state[key] = null; removeHomeCache(key) })
    },
    save(state, { key, scope, data }) {
      if (scope && Object.prototype.hasOwnProperty.call(state, key)) {
        state[key] = { scope, data: copy(data) }
        saveHomeCache(key, scope, state[key].data)
      }
    },
    clear(state, { key, scope }) {
      if (state[key]?.scope === scope) state[key] = null
      removeHomeCache(key, scope)
    },
  },
}
